import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import './TopMenu.scss';
import Icon from '../icon/icon';

class TopMenu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sticky: false
        };
        this.topMenu = React.createRef();
    }
    componentDidMount() {
        window.addEventListener('scroll', () => this.handleScroll());
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', () => this.handleScroll());
    }

    handleScroll() {
        if (this.topMenu) {
            const sticky = this.topMenu.current.offsetTop;
            this.setState({ sticky: (window.pageYOffset > sticky) });
        }
    }

    render() {
        return (
            <div className="header-container">
                <header ref={this.topMenu} className={this.state.sticky ? 'sticky' : ''}>
                    <nav className="navbar">
                        <label className="navbar-toggle" id="js-navbar-toggle" for="chkToggle">
                            <Icon icon={"about"} size={32} color={"#fff"} />
                        </label>
                        <Link to="/" className="logo">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                            >
                                <use xlinkHref={`/assets/svg/Logo.svg#Logo`} />
                            </svg>
                        </Link>
                        <input type="checkbox" id="chkToggle"></input>
                        <ul className="main-nav" id="js-menu">
                            <li>
                                <NavLink className="nav-links" activeClassName="active-link" exact to="/">Home</NavLink>
                            </li>
                            <li>
                                <NavLink className="nav-links" activeClassName="active-link" to="/blog">Blog</NavLink>
                            </li>
                            <li>
                                <NavLink className="nav-links" activeClassName="active-link" to="/contact">Contact</NavLink>
                            </li>
                        </ul>
                    </nav>
                </header>
            </div >
        );
    }
}
export default TopMenu;